import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import UsersIcon from '@material-ui/icons/PeopleAlt';
import ProviderIcon from '@material-ui/icons/Business';
import ChatIcon from '@material-ui/icons/Chat';
import AddCommentIcon from '@material-ui/icons/AddComment';
import ReportIcon from '@material-ui/icons/InsertChart';
import BillingIcon from '@material-ui/icons/CreditCard';
import { Link } from 'react-router-dom';

const useStyles = makeStyles({
  root: {
    padding: '1rem 0',
    width: '100%',
    height: '100%',
  },
});

const Menu = () => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <List>
        <ListItem button component={Link} to='/siteadmin/provider'>
          <ListItemIcon>
            <ProviderIcon />
          </ListItemIcon>
          <ListItemText primary="Providers" />
        </ListItem>
        <ListItem button component={Link} to='/siteadmin/user'>
          <ListItemIcon>
            <UsersIcon />
          </ListItemIcon>
          <ListItemText primary="Users" />
        </ListItem>
        <ListItem button component={Link} to='/siteadmin/reviewmoderation'>
          <ListItemIcon>
            <ChatIcon />
          </ListItemIcon>
          <ListItemText primary="Review Moderation" />
        </ListItem>
        <ListItem button component={Link} to='/siteadmin/servicerequest'>
          <ListItemIcon>
            <AddCommentIcon />
          </ListItemIcon>
          <ListItemText primary="Service Requests" />
        </ListItem>
        <ListItem button component={Link} to='/siteadmin/reports'>
          <ListItemIcon>
            <ReportIcon />
          </ListItemIcon>
          <ListItemText primary="Reports" />
        </ListItem>
        <ListItem button component={Link} to='/siteadmin/billing'>
          <ListItemIcon>
            <BillingIcon />
          </ListItemIcon>
          <ListItemText primary="Billing" />
        </ListItem>
      </List>
    </div>
  );
};

export default Menu;
